// extracted by mini-css-extract-plugin
module.exports =  {"collect-wrapper":"lauAAG9","collectWrapper":"lauAAG9","collect-btn":"IK9Iovp","collectBtn":"IK9Iovp","collected":"bMMRrIj"};